import { useState } from 'react';
import { FaPhone, FaWhatsapp, FaClock } from 'react-icons/fa';
import RequestFormModal from './RequestFormModal';

function ContactSection({ buyLink, onBuyClick }) {
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);

  return (
    <>
      <section className="relative py-24 px-4 sm:px-8 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 overflow-hidden">
        <div className="max-w-7xl mx-auto">
          {/* Get In Touch Button */}
          <div className="text-center mb-10">
            <a 
              href="tel:+918920633120"
              className="inline-flex items-center gap-2 bg-transparent border-2 border-amber-400 text-amber-400 px-8 py-3 rounded-full text-base font-bold hover:bg-amber-400 hover:text-slate-900 hover:scale-105 transition-all duration-300"
            >
              <FaPhone className="text-lg" />
              Get In Touch
            </a>
          </div>

        {/* Title */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white text-center mb-10 drop-shadow-lg">
          For Any Kind of Queries <span className="text-amber-400">Kindly Contact</span>
        </h1>

        {/* Main Contact Card */}
        <div className="max-w-xl mx-auto mb-16">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/30 to-orange-500/30 rounded-3xl blur-lg opacity-50 group-hover:opacity-70 transition duration-500"></div>
            <div className="relative bg-gradient-to-br from-blue-900/60 via-slate-900 to-slate-800/80 border-2 border-amber-500/30 rounded-3xl p-10 sm:p-14 text-center backdrop-blur-sm shadow-[0_20px_40px_rgba(0,0,0,0.4),inset_0_1px_0_rgba(255,255,255,0.1)]">
              {/* Avatar */}
              <div className="relative w-32 h-32 sm:w-36 sm:h-36 mx-auto mb-6 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center text-5xl sm:text-6xl font-black text-slate-900 shadow-[0_20px_40px_rgba(251,191,36,0.4)]">
                SK
              </div>

              {/* Name */}
              <h2 className="text-2xl sm:text-3xl font-black text-white mb-2">
                Mrs. Sanjeet Kaur
              </h2>
              <p className="text-base sm:text-lg text-sky-100 opacity-90 mb-8">
                Customer Support Team
              </p>

              {/* Phone Button */}
              <a 
                href="tel:+918920633120"
                className="inline-flex items-center gap-3 bg-gradient-to-r from-green-500 to-green-600 text-white px-10 py-4 rounded-xl text-xl font-extrabold shadow-[0_10px_20px_rgba(16,185,129,0.4)] hover:shadow-[0_15px_30px_rgba(16,185,129,0.5)] hover:-translate-y-0.5 transition-all duration-300"
              >
                <FaPhone className="text-xl" />
                8920633120
              </a>

              {/* Hours */}
              <p className="flex items-center justify-center gap-2 text-slate-400 text-sm mt-6 opacity-80">
                <FaClock />
                10:00 AM Till 7:00 PM • WhatsApp Call Only
              </p>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <button 
            onClick={() => setIsFormModalOpen(true)}
            className="inline-block bg-gradient-to-r from-amber-400 via-amber-500 to-orange-500 text-slate-900 px-12 sm:px-20 py-4 sm:py-5 rounded-xl text-lg sm:text-2xl font-extrabold shadow-[0_10px_20px_-5px_rgba(251,191,36,0.4)] hover:shadow-[0_20px_30px_-8px_rgba(251,191,36,0.5)] hover:-translate-y-0.5 transition-all duration-200 tracking-wide cursor-pointer"
          >
            Book a call →
          </button>
        </div>
      </div>
    </section>

    {/* Request Form Modal */}
    <RequestFormModal 
      isOpen={isFormModalOpen} 
      onClose={() => setIsFormModalOpen(false)} 
    />
    </>
  );
}

export default ContactSection;
